import { render, staticRenderFns } from "./CompanyEditor.vue?vue&type=template&id=20db0e8f&"
import script from "./CompanyEditor.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports